/**
 * NoPermissionDialog (§3.K — `static/mvc/no_permission/`).
 *
 * Shown when the user tries to open a project they lack access to
 * (`hasPermission === 'no_access'`) instead of navigating (parity 76). A single
 * "ok" button removes the popup.
 *
 * Markup matches the Backbone template exactly:
 *   div#no_permission_popup.popup-wrapper.width-small.active > .popup-content
 *     ├── h2.popup-heading "No Permission!"
 *     ├── .popup-content-part > p "You have No Permission to Access." + p "Contact your Administrator."
 *     └── .popup-control-buttons (button#ok.btn.btn-primary.right "ok")
 *
 * Esc/Enter are handled by the shared global popup handler (usePopupKeys):
 * Enter triggers the autofocused OK button; Esc clicks the Cancel button if any
 * (there is none here, so Esc just dismisses via removal — see usePopupKeys).
 */
interface NoPermissionDialogProps {
  onOk: () => void;
}

const NoPermissionDialog = ({ onOk }: NoPermissionDialogProps) => (
  <div id="no_permission_popup" className="popup-wrapper width-small active">
    <div className="popup-content">
      <h2 className="popup-heading">No Permission!</h2>
      <div className="popup-content-part">
        <p>You have No Permission to Access.</p>
        <p>Contact your Administrator.</p>
      </div>
      <div className="popup-control-buttons">
        <button id="ok" className="btn btn-primary right" type="button" autoFocus onClick={onOk}>
          ok
        </button>
      </div>
    </div>
  </div>
);

export default NoPermissionDialog;
